import services from '@/services.js'

export default async function getFieldTypesAndCustomTypes(organizationId) {
  try {
    const FIELD_TYPES = await services.fieldtypes(organizationId);
    const SCHEME = await services.audienceSchema(organizationId);

    const customTypes = FIELD_TYPES.data.data.groups
      .filter(group => group.group === 'CUSTOM')
      .flatMap(group => group.types)
      .map(type => ({ ...type, value: type.personalizationTag }));

    return SCHEME.data.data.errorCode === 1000
      ? customTypes
      : [...SCHEME.data.data.values, ...customTypes];
  } catch (error) {
    throw error;
  }
}